import { Icon } from '@iconify/react';

const techIcons = [
	{ icon: 'logos:react', label: 'React' },
	{ icon: 'logos:typescript-icon', label: 'TypeScript' },
	{ icon: 'logos:python', label: 'Python' },
	{ icon: 'logos:nodejs-icon', label: 'Node.js' },
	{ icon: 'logos:postgresql', label: 'PostgreSQL' },
	{ icon: 'logos:aws', label: 'AWS' }
] as const;

const additionalIcons = [
	{ icon: 'logos:docker-icon', label: 'Docker' },
	{ icon: 'logos:kubernetes', label: 'Kubernetes' },
	{ icon: 'logos:tailwindcss-icon', label: 'TailwindCSS' },
	{ icon: 'logos:flutter', label: 'Flutter' },
	{ icon: 'logos:mongodb-icon', label: 'MongoDB' },
	{ icon: 'logos:graphql', label: 'GraphQL' }
] as const;

export const TechStack = () => (
	<div className="max-w-5xl mx-auto mb-16 text-center">
		<h3 className="text-2xl font-bold mb-8">Built with Modern Tech Stack</h3>
		<div className="grid grid-cols-3 md:grid-cols-6 gap-8 items-center justify-items-center">
			{[...techIcons, ...additionalIcons].map(({ icon, label }) => (
				<div key={icon} className="group relative">
					<Icon icon={icon} className="text-4xl transform transition-transform group-hover:scale-110" />
					<span className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity text-xs text-gray-400">
						{label}
					</span>
				</div>
			))}
		</div>
	</div>
);
